import { useTranslation } from 'react-i18next';

import { Body1 } from '@myphx-engineering/phx-design-system';

import { getFragment } from '../../../../graphql/client/helpers/get-fragment';
import { PrescriberOrderStatus } from '../../../../graphql/generated/graphql';
import { ConditionalComponent } from '../../../utility/ConditionalComponent';

import type { MedicationOrderProps } from './MedicationOrder';

export const MedicationOrderDetails = ({ order }: MedicationOrderProps) => {
    const { t } = useTranslation();
    const isUnclaimed = order.__typename === 'UnclaimedPrescriberOrder';
    const patientName =
        order.__typename === 'DigitallyReceivedPrescriberOrder'
            ? getFragment(order.patient).fullName
            : undefined;

    const isOnHold =
        order.__typename === 'DigitallyReceivedPrescriberOrder' &&
        order.status === PrescriberOrderStatus.OnHold;

    const hasChangeRequest =
        order.__typename === 'DigitallyReceivedPrescriberOrder' &&
        order.changeRequestDetails != null;

    return (
        <>
            <ConditionalComponent condition={isUnclaimed}>
                <Body1 data-testid="medication-entry-verify-medication-text">
                    {t('cabinet.medicationOrder.verifyPatient')}
                </Body1>
            </ConditionalComponent>
            <ConditionalComponent condition={!isUnclaimed && !!patientName}>
                <Body1 data-testid="medication-entry-patient-name">
                    {t('cabinet.medicationOrder.forName', {
                        name: patientName,
                    })}
                </Body1>
            </ConditionalComponent>
            <ConditionalComponent condition={isOnHold && hasChangeRequest}>
                <Body1 data-testid="medication-entry-change-request-initiated">
                    {t('cabinet.medicationOrder.changeRequestInitiated')}
                </Body1>
            </ConditionalComponent>
            <ConditionalComponent condition={isOnHold && !hasChangeRequest}>
                <Body1 data-testid="medication-entry-on-hold">
                    {t('cabinet.medicationOrder.onHold')}
                </Body1>
            </ConditionalComponent>
        </>
    );
};
